<template>
  <div>
    <b-modal
      id="project-create"
      title="Create a New Project"
      @ok="handelOK"
      @show="getOptionsData()"
      @cancel="closeModal()"
      return-focus="body"
    >
      <div v-if="dataLoaded == false && error == null" class="text-center">
        <b-spinner variant="primary" type="grow" label="Spinning"></b-spinner>
        <p>Loading</p>
      </div>
      <div v-if="dataLoaded == false && error != null" class="text-center">
        <b-spinner variant="danger" type="grow" label="Spinning"></b-spinner>
        <p>{{ error }}</p>
      </div>
      <div v-if="dataLoaded == true">
        <b-form-group
          id="project-name-edit-set"
          :label="projectOptions.projectName.help_text"
          label-for="input-1"
          :invalid-feedback="invalidFeedback.projectName"
          :valid-feedback="validFeedback.projectName"
        >
          <b-form-input
            id="projectName"
            v-model="projectName"
            :state="state.projectName"
            trim
            @keyup="setState('projectName')"
            autocomplete="off"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          id="customer-edit-set"
          :label="projectOptions.customer.help_text"
          label-for="input-2"
          :invalid-feedback="invalidFeedback.customer"
          :valid-feedback="validFeedback.customer"
        >
          <b-form-input
            id="customer"
            v-model="customer"
            :state="state.customer"
            trim
            @keyup="setState('customer')"
            autocomplete="off"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          id="typeOfProject-edit-set"
          :label="projectOptions.typeOfProject.help_text"
          label-for="input-3"
          :invalid-feedback="invalidFeedback.typeOfProject"
          :valid-feedback="validFeedback.typeOfProject"
        >
          <b-form-select
            id="typeOfProject"
            v-model="typeOfProject"
            :options="typeOfProjectSelect"
            text-field="display_name"
            :state="state.typeOfProject"
            trim
            @change="setState('typeOfProject')"
          ></b-form-select>
        </b-form-group>
        <b-form-group
          id="startDate-edit-set"
          :label="projectOptions.startDate.help_text"
          label-for="input-4"
          :invalid-feedback="invalidFeedback.startDate"
          :valid-feedback="validFeedback.startDate"
        >
          <b-form-input
            id="startDate"
            v-model="startDate"
            :state="state.startDate"
            type="date"
            trim
            @change="setState('startDate')"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          id="endDate-edit-set"
          :label="projectOptions.endDate.help_text"
          label-for="input-4"
          :invalid-feedback="invalidFeedback.endDate"
          :valid-feedback="validFeedback.endDate"
        >
          <b-form-input
            id="endDate"
            v-model="endDate"
            :state="state.endDate"
            type="date"
            trim
            @change="setState('endDate')"
          ></b-form-input>
        </b-form-group>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  computed: {
    urlPrefix() {
      return this.$store.getters.urlPrefix;
    },
    error() {
      return this.$store.getters.axiosError;
    }
  },
  mounted: function() {
    // the whole component is a modeal so show it when we mount.
    this.$bvModal.show("project-create");
  },

  methods: {
    getOptionsData() {
      // If project options are not set (we've navigated from outside the project list screen then
      // Get data needed for component via promisified mutation.
      // Only set up component data when data is returned

      //eslint-disable-next-line no-console
      //console.log("in create project get options data");
      if (this.$store.getters.projectOptions != null) {
        //eslint-disable-next-line no-console
        //console.log(this.$store.getters.projectOptions);
        // set project options then loaded flag correctly and do no more
        this.projectOptions = this.$store.getters.projectOptions.actions.POST;
        this.typeOfProjectSelect = this.projectOptions.typeOfProject.choices;
        this.dataLoaded = true;
        return;
      }
      const payload = {
        mutationName: "projectOptions",
        url: this.urlPrefix + "api/project/"
      };
      //eslint-disable-next-line no-console
      //console.log("dispatching options for project created component ");
      this.$store.dispatch("genericOptionsApiCall", payload).then(
        () => {
          //eslint-disable-next-line no-console
          //console.log(" Sucess Got options for created component lets update the data and show the form");
          //set up project options then loaded flag to show form
          this.projectOptions = this.$store.getters.projectOptions.actions.POST;
          this.typeOfProjectSelect = this.projectOptions.typeOfProject.choices;
          this.dataLoaded = true;
        },
        // () => {
        //   //eslint-disable-next-line no-console
        //   //console.error(" Error Got nothing from server. Prompt user to check internet connection and try again");
        // }
      );
    },

    postApi() {
      const data = {
        projectName: this.projectName,
        startDate: this.startDate,
        endDate: this.endDate,
        customer: this.customer,
        typeOfProject: this.typeOfProject,
        aliases: [],
        outcomes: []
      };

      const payload = {
        mutationName: "project",
        url: this.urlPrefix + "api/project/",
        data: data
      };
      this.$store.dispatch("genericPostApiCall", payload).then(
        () => {
          // halt loader, close modal and nav back to projects page
          this.dataLoaded = true;
          this.$bvModal.hide("project-create");
          this.$router.push("/projects/");
        },
        () => {
          // stop data loder log error
          this.dataLoaded = true;
          //eslint-disable-next-line no-console
          //console.log(reject);
        }
      );
      // while we wait for the prommise set the data loader
      this.dataLoaded = false;
    },

    setState(fieldName) {
      //eslint-disable-next-line no-console
      //("wooo in set state method" + fieldName);
      if (fieldName == "projectName" || fieldName == "__all__") {
        this.state.projectName = this.projectName.length > 3;
      }
      if (fieldName == "customer" || fieldName == "__all__") {
        this.state.customer = this.customer.length > 3;
      }
      if (fieldName == "typeOfProject" || fieldName == "__all__") {
        this.state.typeOfProject = this.typeOfProjectSelect.some(
          element => element.value === this.typeOfProject
        );
      }
      if (fieldName == "startDate" || fieldName == "__all__") {
        // perform date in past check setting this.dateInPast
        this.dateValidation();
      }
      if (fieldName == "endDate" || fieldName == "__all__") {
        this.dateValidation();
      }
    },

    dateValidation() {
      // trap for empty dates (an incorecly edited data in the template shows as empty in data)
      if (this.startDate == "") {
        this.state.startDate = false;
        this.invalidFeedback.startDate = "You need to enter a valid date";
        return;
      } else {
        this.state.startDate = true;
      }

      if (this.endDate == "") {
        this.state.endDate = false;
        this.invalidFeedback.endDate = "You need to enter a valid date";
        return;
      } else {
        this.state.endDate = true;
      }

      //trap for end date before start date
      const start = new Date(this.startDate);
      const end = new Date(this.endDate);
      if (start < end) {
        this.state.endDate = true;
        this.state.startDate = true;
      } else {
        this.state.endDate = false;
        this.state.startDate = false;
        this.invalidFeedback.endDate =
          "The end date must be after the start date";
        this.invalidFeedback.startDate =
          "The start date must be before the end date";
      }
    },

    validate() {
      // Check all states are true.
      var item;
      for (item in this.state) {
        if (this.state[item] != true) {
          return false;
        }
      }
      return true;
    },

    handelOK(bvModalEvt) {
      // if we are in an error state don't ok call dismiss error then close modal method
      if (this.error != null) {
        this.closeModal();
        return;
      }

      // check state of all fields
      this.setState("__all__");
      // validate date, stop modal closing on ok
      // call or dont call the post api method

      
      if (this.validate() == false) {
        //eslint-disable-next-line no-console
        //console.log(this.validate());
        bvModalEvt.preventDefault();
        return;
      }
      //eslint-disable-next-line no-console
      //console.log("after if " + this.validate());
      this.postApi();
    },

    closeModal() {
      this.dismissError();
      this.$bvModal.hide("project-create");
      this.$router.push("/projects/");
    },
    dismissError() {
      this.$store.dispatch("axiosError", null);
    },
  },
   

  data() {
    return {
      dataLoaded: false,
      projectName: "",
      startDate: "",
      endDate: "",

      typeOfProject: "",
      funder: "",
      customer: "",
      validFeedback: {
        projectName: "Thanks",
        startDate: "Thanks",
        endDate: "Thanks",
        typeOfProject: "Thanks",
        customer: "Thanks"
      },
      invalidFeedback: {
        projectName: "You need to enter at least four characters",
        startDate: "You need to enter a valid date",
        endDate: "You need to enter a valid date",
        typeOfProject: "Select how this project is funded",
        customer: "You need to enter at least four characters"
      },
      state: {
        projectName: null,
        startDate: null,
        endDate: null,
        typeOfProject: null,
        customer: null
      },

      projectOptions: null,
      typeOfProjectSelect: null
    };
  }
};
</script>

<style scoped></style>
